<template>
  <transition name="fade">
    <div
        v-if="isModalOpen"
        class="fixed inset-0 bg-black/30 flex items-center justify-center z-50 p-4"
        @click.self="closeModal"
    >
      <transition name="popup">
        <div
            v-if="isModalOpen"
            class="bg-white w-full max-w-md rounded-2xl p-6 shadow-2xl"
        >
          <h2 class="text-lg font-bold text-gray-900 mb-4">Add a Reply</h2>
          <form @submit.prevent="submitReply">
            <div class="mb-3">
              <label class="block text-sm font-medium text-gray-700 mb-1">Reply</label>
              <textarea
                  v-model="replyForm.message"
                  class="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-600 focus:border-transparent outline-none resize-none"
                  rows="4"
                  required
              ></textarea>
            </div>
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-700 mb-1">Image</label>
              <FileUpload
                  mode="basic"
                  multiple
                  name="replyImage"
                  accept="image/*"
                  chooseLabel="Upload Image"
                  class="p-button-sm w-full custom-orange-btn !bg-slate-600 !border-white"
                  @select="onFileSelect"
                  auto
                  customUpload
              />
              <div v-if="imagePreview" class="mt-3 flex flex-shrink-0 flex-wrap gap-2">
                <img
                    v-for="(image,index) in imagePreview"
                    :key="'preview'+index"
                    @click="removeImage(index)"
                    :src="image"
                    alt="Preview"
                    class="w-16 h-16 object-cover rounded-lg cursor-pointer"
                />
              </div>
            </div>
            <div class="flex justify-end gap-3">
              <button
                  type="button"
                  @click="closeModal"
                  class="px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50 transition"
              >
                Cancel
              </button>
              <button
                  type="submit"
                  class="justify-center flex items-center px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition"
                  :disabled="loading"
              >
                <svg
                    v-if="loading"
                    class="animate-spin h-5 w-5 mr-2 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                  <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                  ></circle>
                  <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  ></path>
                </svg>
                <span>{{ loading ? 'Submitting...' : 'Submit' }}</span>
              </button>
            </div>
          </form>
        </div>
      </transition>
    </div>
  </transition>
</template>
<script setup>

import {ref} from "vue";
import store from "@/store";
import FileUpload from 'primevue/fileupload'
import {useToast} from "primevue/usetoast";

const emit = defineEmits(['reload'])

const props = defineProps({
  review_id: {
    type: Number,
    required: true
  }
})
const isModalOpen = defineModel('isModalOpen', {type: Boolean, default: false})
const replyForm = ref({
  message: '',
  review_id: props.review_id,
  url: [],
  imagePreview: null,
})

const imagePreview = ref([])

const loading = ref(false)
const toast = useToast();
const errors = ref({
  message: [],
  review_id: [],
})


const onFileSelect = (event) => {
  const filesArray = Array.from(event.files || []);
  filesArray.forEach(file => {
    imagePreview.value.push(URL.createObjectURL(file))
  })
  replyForm.value.url.push(...filesArray); // Convert FileList to an array
}

const removeImage=(index)=>{
  imagePreview.value.splice(index, 1);
  replyForm.value.url.splice(index, 1);
}

const closeModal = () => {
  isModalOpen.value = false
  replyForm.value = {message: '', url: [], review_id: props.review_id}
  imagePreview.value = []
}

const showSuccess = (detail) => {
  toast.add({
    severity: "success",
    summary: "Success",
    detail,
    life: 3000,
  });
};

const submitReply = () => {
  loading.value = true
  store.dispatch('addAdminReply', replyForm.value).then(() => {
    showSuccess('Reply submitted')
  }).catch(err => {
    errors.value = err.response.data.errors
  }).finally(() => {
    loading.value = false
    closeModal()
    emit('reload')
  })
}

</script>